const BenchmarkChart = {
	openTab: function(e, tabID) {
		var i, tabcontent, tablinks;

		tabcontent = document.getElementsByClassName("tab-content");
		for (i = 0; i < tabcontent.length; i++) {
			tabcontent[i].style.display = "none";
		}

		tablinks = document.getElementsByClassName("bar-chart__tab-link");
		for (i = 0; i < tablinks.length; i++) {
			tablinks[i].className = tablinks[i].className.replace(" active", "");
		}

		document.getElementById(tabID).style.display = "flex";
		e.currentTarget.className += " active";
	},

	init: function() {
		const tabButtons = document.getElementsByClassName("bar-chart__tab-link");
		if (tabButtons.length<1){
			return
		}
		for (let button of tabButtons) {
			button.addEventListener('click', (e) => {
				this.openTab(e, e.target.dataset.name);
			});
		}
		tabButtons[0].click()
	}
};

export default BenchmarkChart;

document.addEventListener("DOMContentLoaded", () => {
  BenchmarkChart.init();
});